export default {
    SET_PREFERRED_CURRENCY: 'CURRENCY/SET_PREFERRED_CURRENCY',
    SET_CURRENCY_IF_NOT_CHOSEN: 'CURRENCY/SET_CURRENCY_IF_NOT_CHOSEN'
};
